import { Product } from '../types';

// ============================================
// SPECIAL UNIVERSAL CONNECTORS - 1 & 2 POLE
// ============================================

// 1 POLE SPECIAL CONNECTORS
export const specialConnector1PoleProducts: Product[] = [
  {
    id: "special-conn-maruti-fuse-1p-f",
    name: "Maruti Fuse Link 1 Pole Female Special Connector",
    slug: "special-maruti-fuse-link-1-pole-female",
    category: "Special Universal Connectors",
    subcategory: "1 Pole Connectors",
    description: "Maruti fuse link 1 pole female connector with 8mm deluxe wire. 9 inch long.",
    partNumber: "SH2100101",
    image: "/products/special-universal-connectors/special-universal/SH2100101.jpg",
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Compatible": "Maruti Fuse Link",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "1-pole", "maruti", "fuse-link", "female"],
    applications: ["Maruti", "Fuse Link"],
  },
  {
    id: "special-conn-maruti-fuse-1p-m",
    name: "Maruti Fuse Link 1 Pole Male Special Connector",
    slug: "special-maruti-fuse-link-1-pole-male",
    category: "Special Universal Connectors",
    subcategory: "1 Pole Connectors",
    description: "Maruti fuse link 1 pole male connector with 8mm deluxe wire.",
    partNumber: "SH2100102",
    image: "/products/special-universal-connectors/special-universal/SH2100102.jpg",
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Male",
      "Compatible": "Maruti Fuse Link",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "1-pole", "maruti", "fuse-link", "male"],
    applications: ["Maruti", "Fuse Link"],
  },
  {
    id: "special-conn-h1-holder-1p-f-4mm",
    name: "H1 Holder 1 Pole Female - 4mm Wire",
    slug: "special-h1-holder-1-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "1 Pole Connectors",
    description: "H1 headlight holder 1 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100111",
    image: "/products/special-universal-connectors/special-universal/SH2100111.jpg",
    featured: true,
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Compatible": "H1 Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "1-pole", "h1-holder", "headlight", "female"],
    applications: ["H1 Headlight Holder"],
  },
  {
    id: "special-conn-h1-holder-1p-f-5mm",
    name: "H1 Holder 1 Pole Female - 5mm Wire",
    slug: "special-h1-holder-1-pole-female-5mm",
    category: "Special Universal Connectors",
    subcategory: "1 Pole Connectors",
    description: "H1 headlight holder 1 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100112",
    image: "/products/special-universal-connectors/special-universal/SH2100112.jpg",
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Compatible": "H1 Holder",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "1-pole", "h1-holder", "headlight", "female"],
    applications: ["H1 Headlight Holder"],
  },
];

// 2 POLE SPECIAL CONNECTORS (Part 1 - Universal/Tata)
export const specialConnector2PoleUniversalProducts: Product[] = [
  {
    id: "special-conn-universal-tata-2p-f-8mm-1",
    name: "Universal Tata 2 Pole Female - 8mm Wire",
    slug: "special-universal-tata-2-pole-female-8mm-1",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with 8mm deluxe wire.",
    partNumber: "SH2100201",
    image: "/products/special-universal-connectors/special-universal/SH2100201.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles", "Universal"],
  },
  {
    id: "special-conn-universal-tata-2p-m-8mm",
    name: "Universal Tata 2 Pole Male - 8mm Wire",
    slug: "special-universal-tata-2-pole-male-8mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole male connector with 8mm deluxe wire.",
    partNumber: "SH2100202",
    image: "/products/special-universal-connectors/special-universal/SH2100202.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Compatible": "Universal Tata",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "male"],
    applications: ["Tata Vehicles", "Universal"],
  },
  {
    id: "special-conn-tata-fan-coupler-2p-f",
    name: "Tata Fan Coupler 2 Pole Female",
    slug: "special-tata-fan-coupler-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata fan coupler 2 pole female connector with 8mm deluxe wire.",
    partNumber: "SH2100203",
    image: "/products/special-universal-connectors/special-universal/SH2100203.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata Fan Coupler",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "fan-coupler", "female"],
    applications: ["Tata Fan Coupler"],
  },
  {
    id: "special-conn-tata-fan-coupler-2p-m",
    name: "Tata Fan Coupler 2 Pole Male",
    slug: "special-tata-fan-coupler-2-pole-male",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata fan coupler 2 pole male connector with 8mm deluxe wire.",
    partNumber: "SH2100204",
    image: "/products/special-universal-connectors/special-universal/SH2100204.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Compatible": "Tata Fan Coupler",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "fan-coupler", "male"],
    applications: ["Tata Fan Coupler"],
  },
  {
    id: "special-conn-h7-holder-2p-f-4mm",
    name: "H7 Holder 2 Pole Female - 4mm Wire",
    slug: "special-h7-holder-2-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "H7 headlight holder 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100211",
    image: "/products/special-universal-connectors/special-universal/SH2100211.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "H7 Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "h7-holder", "headlight", "female"],
    applications: ["H7 Headlight Holder"],
  },
  {
    id: "special-conn-h7-holder-2p-f-5mm",
    name: "H7 Holder 2 Pole Female - 5mm Wire",
    slug: "special-h7-holder-2-pole-female-5mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "H7 headlight holder 2 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100212",
    image: "/products/special-universal-connectors/special-universal/SH2100212.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "H7 Holder",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "h7-holder", "headlight", "female"],
    applications: ["H7 Headlight Holder"],
  },
  {
    id: "special-conn-h11-holder-2p-f",
    name: "H11 Holder 2 Pole Female",
    slug: "special-h11-holder-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "H11 headlight holder 2 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100224",
    image: "/products/special-universal-connectors/special-universal/SH2100224.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "H11 Holder",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "h11-holder", "headlight", "female"],
    applications: ["H11 Headlight Holder"],
  },
  {
    id: "special-conn-maximo-h8-fog-2p-f",
    name: "Mahindra Maximo H8 Fog Lamp 2 Pole Female",
    slug: "special-maximo-h8-fog-lamp-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Mahindra Maximo H8 fog lamp 2 pole female connector with special wire.",
    partNumber: "SH2100221",
    image: "/products/special-universal-connectors/special-universal/SH2100221.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo H8 Fog Lamp",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "maximo", "fog-lamp", "h8", "female"],
    applications: ["Mahindra Maximo", "Fog Lamp"],
  },
  {
    id: "special-conn-al-fog-lamp-2p-f",
    name: "Ashok Leyland Fog Lamp 2 Pole Female",
    slug: "special-al-fog-lamp-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Ashok Leyland fog lamp 2 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100223",
    image: "/products/special-universal-connectors/special-universal/SH2100223.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland Fog Lamp",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "ashok-leyland", "fog-lamp", "female"],
    applications: ["Ashok Leyland", "Fog Lamp"],
  },
];

// 2 POLE SPECIAL CONNECTORS (Part 2 - Sensors/Switches)
export const specialConnector2PoleSensorProducts: Product[] = [
  {
    id: "special-conn-tata-corner-light-2p-f",
    name: "Tata Corner Light 2 Pole Female",
    slug: "special-tata-corner-light-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata corner light 2 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100227",
    image: "/products/special-universal-connectors/special-universal/SH2100227.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata Corner Light",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "corner-light", "female"],
    applications: ["Tata Corner Light"],
  },
  {
    id: "special-conn-tata-injector-2p-f",
    name: "Tata Injector 2 Pole Female",
    slug: "special-tata-injector-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata injector 2 pole female connector with special wire.",
    partNumber: "SH2100228",
    image: "/products/special-universal-connectors/special-universal/SH2100228.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "injector", "female"],
    applications: ["Tata Injector", "Fuel Injection"],
  },
  {
    id: "special-conn-kseries-injector-cng-diesel-2p-f",
    name: "Injector K Series CNG & Diesel 2 Pole Female",
    slug: "special-kseries-injector-cng-diesel-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Injector K Series CNG & Diesel 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100229",
    image: "/products/special-universal-connectors/special-universal/SH2100229.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "K Series CNG & Diesel Injector",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "k-series", "injector", "cng", "diesel", "female"],
    applications: ["Maruti K Series", "CNG", "Diesel Injector"],
  },
  {
    id: "special-conn-drv-sensor-fiesta-2p-f",
    name: "DRV Sensor Fiesta Diesel 2 Pole Female",
    slug: "special-drv-sensor-fiesta-diesel-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "DRV sensor for Fiesta Diesel 2 pole female connector with special wire.",
    partNumber: "SH2100230",
    image: "/products/special-universal-connectors/special-universal/SH2100230.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Fiesta Diesel DRV Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "drv-sensor", "fiesta", "diesel", "female"],
    applications: ["Fiesta Diesel", "DRV Sensor"],
  },
  {
    id: "special-conn-universal-tata-2p-f-special",
    name: "Universal Tata 2 Pole Female - Special Wire",
    slug: "special-universal-tata-2-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with special wire.",
    partNumber: "SH2100231",
    image: "/products/special-universal-connectors/special-universal/SH2100231.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles", "Universal"],
  },
  {
    id: "special-conn-universal-tata-2p-f-4mm",
    name: "Universal Tata 2 Pole Female - 4mm Wire",
    slug: "special-universal-tata-2-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Universal Tata 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100234",
    image: "/products/special-universal-connectors/special-universal/SH2100234.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-tata-egr-valve-2p-f",
    name: "Tata EGR Valve 2 Pole Female",
    slug: "special-tata-egr-valve-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata EGR valve 2 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100236",
    image: "/products/special-universal-connectors/special-universal/SH2100236.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata EGR Valve",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "egr-valve", "female"],
    applications: ["Tata EGR Valve", "Emission Control"],
  },
  {
    id: "special-conn-maximo-2p-f-special",
    name: "Mahindra Maximo 2 Pole Female",
    slug: "special-maximo-2-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Mahindra Maximo 2 pole female connector with special wire.",
    partNumber: "SH2100237",
    image: "/products/special-universal-connectors/special-universal/SH2100237.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-thermoswitch-kseries-2p-f",
    name: "Thermoswitch K Series Maruti Swift Petrol 2 Pole Female",
    slug: "special-thermoswitch-kseries-maruti-swift-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Thermoswitch for K Series Maruti Swift Petrol 2 pole female connector with special wire.",
    partNumber: "SH2100238",
    image: "/products/special-universal-connectors/special-universal/SH2100238.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "K Series Maruti Swift Petrol Thermoswitch",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "thermoswitch", "k-series", "maruti", "swift", "female"],
    applications: ["Maruti Swift Petrol", "Thermoswitch"],
  },
  {
    id: "special-conn-honda-accord-indicator-2p-f",
    name: "Honda Accord & Side Indicator Light 2 Pole Female",
    slug: "special-honda-accord-indicator-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Honda Accord & side indicator light 2 pole female connector with special wire.",
    partNumber: "SH2100241",
    image: "/products/special-universal-connectors/special-universal/SH2100241.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Honda Accord, Side Indicator Light",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "honda", "accord", "indicator", "female"],
    applications: ["Honda Accord", "Side Indicator"],
  },
  {
    id: "special-conn-injector-kseries-cng-2p-f",
    name: "Injector K Series Maruti CNG 2 Pole Female",
    slug: "special-injector-kseries-maruti-cng-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Injector K Series Maruti CNG 2 pole female connector with special wire.",
    partNumber: "SH2100242",
    image: "/products/special-universal-connectors/special-universal/SH2100242.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "K Series Maruti CNG Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "injector", "k-series", "maruti", "cng", "female"],
    applications: ["Maruti CNG", "Injector"],
  },
  {
    id: "special-conn-high-pressure-switch-santro-indica-2p-f",
    name: "High Pressure Switch Santro & Indica 2 Pole Female",
    slug: "special-high-pressure-switch-santro-indica-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "High pressure switch for Santro & Indica 2 pole female connector with special wire.",
    partNumber: "SH2100243",
    image: "/products/special-universal-connectors/special-universal/SH2100243.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Santro & Indica High Pressure Switch",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "high-pressure", "santro", "indica", "female"],
    applications: ["Santro", "Indica", "AC High Pressure Switch"],
  },
  {
    id: "special-conn-tata-pwr-window-2p-f",
    name: "Tata PWR Window 2 Pole Female",
    slug: "special-tata-pwr-window-2-pole-female",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Tata power window 2 pole female connector with special wire.",
    partNumber: "SH2100244",
    image: "/products/special-universal-connectors/special-universal/SH2100244.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Tata Power Window",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "tata", "power-window", "female"],
    applications: ["Tata Power Window"],
  },
  {
    id: "special-conn-2p-f-special-generic",
    name: "Universal 2 Pole Female - Special Wire",
    slug: "special-universal-2-pole-female-special-generic",
    partNumber: "SH2100246",
    image: "/products/special-universal-connectors/special-universal/SH2100246.jpg",
    category: "Special Universal Connectors",
    subcategory: "2 Pole Connectors",
    description: "Generic 2 pole female connector with special wire.",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
];

// Note: This is Part 1 of Special Universal Connectors (1-2 pole)
// Additional 2-pole variants and higher pole counts will be in separate files
